import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useI18n } from "@/lib/i18n";
import { SITE_COPY } from "@/lib/siteContent";

export function FaqSection() {
  const { lang } = useI18n();
  const c = SITE_COPY[lang].faq;

  return (
    <section className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-24">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">{c.eyebrow}</p>
      <h2 className="mt-3 font-serif text-3xl text-foreground md:text-5xl">{c.title}</h2>
      <p className="mt-3 text-sm text-muted-foreground md:text-base">{c.subtitle}</p>

      <Accordion type="single" collapsible className="mt-8">
        {c.items.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`}>
            <AccordionTrigger className="text-left text-base font-medium text-foreground">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
